import React from 'react';
import PropTypes from 'prop-types';
// import { propTypes as rowPropTypes } from './row';
import ChannelCard from '../card/channel_card';
import getUniqueKeyForCard from '../../utils/getUniqueKeyForCard';
import {map, take} from 'lodash';

const ThreeChannelRow = ({
  cards,
  dataAttributes,
  type,
  moduleType
}, {
  isPreviewPage
}) => (
  <div className="row three-channel" {...dataAttributes} >
    <div className="three-channel-inner">
      {
        map(take(cards, 3), (card) => (
          <ChannelCard
            {...card}
            rowType={type}
            moduleType={moduleType}
            key={getUniqueKeyForCard(card, isPreviewPage)}
          />
        ))
      }
    </div>
  </div>
);

// ThreeChannelRow.propTypes = Object.assign({ ...rowPropTypes }, {
//   dataAttributes: PropTypes.object.isRequired
// });

ThreeChannelRow.defaultProps = {
  dataAttributes: {}
};

ThreeChannelRow.contextTypes = {
  isPreviewPage: PropTypes.bool.isRequired
};

export default ThreeChannelRow;
